// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3BOd2","range":"MonthRangeSwitch_range__3gH7F","disabled":"MonthRangeSwitch_disabled__3uOBr"};